import "./TakeawayCareModal.scss";

import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import GradientButton from "../../../../components/buttons/gradientButton/GradientButton";

const TakeawayCareModal = ({ open, setOpen, message }) => {
  const { t } = useTranslation("takeaway");

  if(!message) message = t("message");

  return (
    <Modal
      onHide={() => setOpen(false)}
      show={open}
      centered
      className="takeway-care-modal"
    >
      <Modal.Header className="header-section">
        <p className="modal-title">{t("warning")}</p>
      </Modal.Header>

      <Modal.Body className="body-section">
        <p className="message">{message}</p>
        <div className="button-container">
          <GradientButton onPress={() => setOpen(false)}>{t("back")}</GradientButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TakeawayCareModal;
